import type { Version, BaseServiceUrls } from '../../utils/api/fetcher/fetcher';

export function prependApiBase(
  endpoint: `/${string}`,
  service: BaseServiceUrls,
  version: Version
) {
  return `/api${service}${version}${endpoint}`;
}
